<!--Main Info-->
<div>
	<!--Info Grid-->
	<div class="MainGrid4Col">
		<!----------------------------------------------------->
		<h4 class="CenterHeading TopMargin">Driver's License</h4>
		<!----------------------------------------------------->
		<label>State:</label>
		<p>{{ State }}</p>

		<label class="MiddleCol">License Number:</label>
		<p>{{ LicenseNbr }}</p>

		<label>Issue Date:</label>
		<p>{{ IssueDate }}</p>

		<label class="MiddleCol">Expire Date:</label>
		<p>{{ ExpireDate }}</p>
		<!----------------------------------------------------->
	</div>

	<div class="hr-line-dashed ItemBorder"></div>

	<div class="MainGrid4Col">
		<!----------------------------------------------------->
		<h4 class="CenterHeading">Address</h4>
		<!----------------------------------------------------->
		<label>Address:</label>
		<p>{{ Address }}</p>

		<label class="MiddleCol">City:</label>
		<p>{{ City }}</p>

		<label>Zip Code:</label>
		<p>{{ ZipCode }}</p>
		<!----------------------------------------------------->
	</div>

	<div class="hr-line-dashed ItemBorder"></div>

	<div class="MainGrid4Col">
		<!----------------------------------------------------->
		<h4 class="CenterHeading">Contact Info</h4>
		<!----------------------------------------------------->
		<label>Phone Number:</label>
		<p>{{ PhoneNbr }}</p>

		<label class="MiddleCol">Email:</label>
		<p>{{ Email }}</p>
		<!----------------------------------------------------->
	</div>

	<div class="hr-line-dashed ItemBorder"></div>

	<div class="MainGrid4Col">
		<!----------------------------------------------------->
		<h4 class="CenterHeading">Visit Data</h4>
		<!----------------------------------------------------->
		<label># of Visits:</label>
		<p>{{ VisitCount }}</p>

		<label class="MiddleCol"># of Pass Scans:</label>
		<p>{{ ScanCount }}</p>

		<label>First Visit:</label>
		<p>{{ FirstVisit }}</p>

		<label class="MiddleCol">Last Visit:</label>
		<p>{{ LastVisit }}</p>

		<label>Longest Visit:</label>
		<p>{{ LongestVisit }}</p>

		<label class="MiddleCol">Shortest Visit:</label>
		<p>{{ ShortestVisit }}</p>

		<label>Average Visit Duration:</label>
		<p>{{ AverageVisit }}</p>
		<!----------------------------------------------------->
	</div>

	<div *ngIf="SelectedVisitor != undefined" class="hr-line-dashed ItemBorder"></div>
</div>

<!--Visit Lists-->
<div *ngIf="SelectedVisitor != undefined" class="TableGrid">
	<!--Left Col, Scanned at Locations-->
	<div class="TableBorder">
		<h4 class="CenterText">Locations Scanned At</h4>
		<caass-ms-demographic-location-table [lstFacilityLocation]="lstLocationInfo" [loading]="loading"> </caass-ms-demographic-location-table>
	</div>

	<!--Right Col, Visitees Visited-->
	<div class="TableBorder">
		<h4 class="CenterText">People/Places Visited</h4>
		<caass-ms-demographic-visitee-table [lstVisitee]="lstVisiteeInfo" [loading]="loading"> </caass-ms-demographic-visitee-table>
	</div>
</div>
